import {
  Campaign,
  CampaignAdvAccountStatus,
  CampaignDesiredFollowers,
  CampaignMediaType,
  CampaignProjectType,
} from '~/lib/types/Campaign'
import { createCampaignBillingDetailsMock } from './createCampaignBillingDetailsMock'
import { createCampaignOfferCountMock } from './createCampaignOfferCountMock'
import { createPlanMock } from './createPlanMock'
import { staticPath } from '~/lib/$path'
import { CampaignCategory } from '~/generated/graphql'

export const createCampaignMock = (mock?: Partial<Campaign>): Campaign => ({
  id: mock?.id ?? 2222,
  status: mock?.status ?? 'approved',
  name: mock?.name ?? '【キャンペーン名】これはモックです',
  url: mock?.url ?? 'https://toridori.co.jp',
  companion: mock?.companion ?? 'accompanying',
  address: mock?.address ?? '東京都○○区○○○○○○○○○○○○○○',
  advAccountStatus: mock?.advAccountStatus ?? CampaignAdvAccountStatus.AccountNotPublished,
  age: mock?.age ?? 'all_age',
  ageLimit: mock?.ageLimit ?? 'over_twenties',
  attention: mock?.attention ?? '',
  category: mock?.category ?? CampaignCategory.Product,
  categoryI18n: mock?.categoryI18n ?? '',
  summary: mock?.summary ?? 'こちらはキャンペーンの概要になります。テストデータテストデータ。',
  wantInfluencer: mock?.wantInfluencer ?? '200',
  sponsorService: mock?.sponsorService ?? '提供するサービス名',
  sponsorServicePrice: mock?.sponsorServicePrice ?? 4000,
  sponsorServicePriceIntax: mock?.sponsorServicePriceIntax ?? 4400,
  gender: mock?.gender ?? 'woman',
  target: mock?.target ?? '求めるインフルエンサー像はこんな人です。',
  gross: mock?.gross ?? 10000,
  followerMinLimit: mock?.followerMinLimit ?? 500,
  selectionMaxLimit: mock?.selectionMaxLimit ?? 100,
  selectionMaxLimitRemain: mock?.selectionMaxLimitRemain ?? 100,
  offerStarted: mock?.offerStarted ?? '2021-07-29T05:36:38.442Z',
  offerEnded: mock?.offerEnded ?? '2021-07-29T05:36:38.442Z',
  postStarted: mock?.postStarted ?? '2021-07-29T05:36:38.442Z',
  postEnded: mock?.postEnded ?? '2021-07-29T05:36:38.442Z',
  coverImages: mock?.coverImages ?? [
    {
      url: staticPath.campaign_placeholder.placeholder_1_jpg,
    },
    {
      url: staticPath.campaign_placeholder.placeholder_2_jpg,
    },
    {
      url: staticPath.campaign_placeholder.placeholder_3_jpg,
    },
  ],
  reservation: mock?.reservation ?? 'discuss',
  companyName: mock?.companyName ?? 'toridori inc.',
  createdAt: mock?.createdAt ?? new Date('2021-07-29T05:36:38.442Z'),
  desiredFollowers: mock?.desiredFollowers ?? CampaignDesiredFollowers.FewFollowers,
  mediaType: mock?.mediaType ?? CampaignMediaType.Picture,
  mediaTypeI18n: mock?.mediaTypeI18n ?? '',
  nearestStation: mock?.nearestStation ?? '東京駅',
  location: mock?.location ?? {
    stationName: '東京駅',
  },
  offerAutoMessage: mock?.offerAutoMessage ?? '',
  plan: createPlanMock(mock?.plan),
  projectType: mock?.projectType ?? CampaignProjectType.Monitor,
  selectionLimitOver: mock?.selectionLimitOver ?? false,
  campaignSnsRequirements: mock?.campaignSnsRequirements ?? [
    {
      id: '1111',
      postFooter: '#pr #トリドリベース @testshop',
      snsType: 'instagram',
      tagList: 'pr,トリドリベース',
      requestUrl: '@toridoribase',
    },
    {
      id: '1111',
      postFooter: '#pr #トリドリベース @testshop',
      snsType: 'twitter',
      tagList: 'pr,トリドリベース',

      requestUrl: '@toridoribase',
    },
    {
      id: '1111',
      postFooter: '#pr #トリドリベース @testshop',
      snsType: 'tiktok',
      tagList: 'pr,トリドリベース',
      requestUrl: '@toridoribase',
    },
  ],
  offerCount: createCampaignOfferCountMock(mock?.offerCount),
  billingDetails: createCampaignBillingDetailsMock(mock?.billingDetails),
  commission: mock?.commission ?? 0,
  needDelivery: mock?.needDelivery ?? true,
  question: mock?.question ?? '',
  canTakeBack: mock?.canTakeBack ?? false,
  reservableScheduleCount: mock?.reservableScheduleCount ?? 0,
  scheduleType: mock?.scheduleType ?? null,
  regularlyPublishedStatus: mock?.regularlyPublishedStatus ?? 'on',
  regularlyPublishedExecutionDay: mock?.regularlyPublishedExecutionDay ?? 1,
  costHandlingMethod: mock?.costHandlingMethod ?? 'no_charge_campaign',
  influencerBurdenRate: mock?.influencerBurdenRate ?? 0,
})
